const sourceMap = new Map([
    ['ONLINE', 'Online'],
    ['POSTAL', 'Postal'],
]);

export const caseSourceMapper = (value: string): string => {
    return sourceMap.get(value) ?? 'Unknown';
}
